
const scrollToTop = () => {
  if (document.getElementById('main')) {
    document.getElementById('main').scroll({ top: 0, behavior: 'smooth' })
  }
}
export {
  scrollToTop
}
